import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { LoadingService } from 'src/app/services/loading.service';
import { IntegrationsService } from '../../../services/integration/integrations.service';
import { TrainingLocationTypeModel } from '../../../models/training/training-location-type.model';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-teams-meetings',
    templateUrl: './teams-meetings.component.html',
    styleUrl: './teams-meetings.component.css',
    standalone: false
})
export class TeamsMeetingsComponent {
  constructor(
    private activatedRoute: ActivatedRoute,
    private loadingService: LoadingService,
    private router: Router,
    private toastrService: ToastrService,
    private integrationsService: IntegrationsService,
    private translateService: TranslateService,
  ) {}

  ngOnInit(): void {
    debugger
    const code = this.activatedRoute.snapshot.queryParams['code'] ?? null;

    if (code) {
      const obs = this.integrationsService.integrate(
        TrainingLocationTypeModel.MsTeamsMeetings,
        code,
        IntegrationsService.teamsMeetingsRedirectUrl
      );
      this.loadingService.load(obs).subscribe(() => {
        this.toastrService.success(
          this.translateService.instant('INTEGRATIONS.TEAMS-INTEGRATION-SUCCESSFUL')
        );
        this.router.navigate(['integrations']);
      });
    } else {
      this.router.navigate([IntegrationsService.integrationsUrl])
    }
  }
}
